import cn from 'classnames'
import React from 'react'

import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'

import { OtpInput } from './OTPInputBoxes'

import * as Styles from './styles'
import './index.css'

interface OtpInputControllerProps {
   onChange: (code: string) => void
   otpValue: string
   isError?: boolean
   label?: string
   errorMessage?: string
   shouldAutoFocus: boolean
   isDisabled?: boolean
   inputClassName?: string
   inputFocusClassName?: string
   errorClassName?: string
   apiStatus?: number
   labelStyles?: string
   otpContainerStyles?: string
   containerStyle?: string
   numInputs?: number
   onBlur?: (event: React.SyntheticEvent) => void

   isFocus?: boolean
   hideSeparator?: boolean
}

export default function SixBoxesOtpInputField({
   onChange,
   otpValue,
   isError,
   label,
   shouldAutoFocus,
   isDisabled,
   inputClassName,
   inputFocusClassName,
   errorClassName,
   apiStatus,
   containerStyle,
   numInputs,
   onBlur,
   isFocus,
   hideSeparator
}: OtpInputControllerProps) {
   const { theme } = useAppTheme()
   const { sixBoxesInputField: sixBoxesInputTheme } = theme.auth.login.otp
   const { otpInputs: otpInputTheme } = theme.auth.login

   return (
      <div className={cn(Styles.otpInputContainerStyles)}>
         <span
            className={cn(
               Styles.labelContainerStyles,
               Styles.otpFieldLabelStyles,
               sixBoxesInputTheme.labelTextColor
            )}
         >
            {label}
         </span>
         <OtpInput
            value={otpValue}
            onChange={onChange}
            numInputs={numInputs ? numInputs : 6}
            hasErrored={isError}
            inputStyle={
               inputClassName
                  ? inputClassName
                  : cn(
                       Styles.otp_InputContainer_Styles,
                       otpInputTheme.otpInputBGColor,
                       otpInputTheme.otpInputDisabledBorderColor,
                       otpInputTheme.otpInputTextColor
                    )
            }
            focusStyle={
               inputFocusClassName
                  ? inputFocusClassName
                  : cn(
                       Styles.otpInputFocusStyleStyles,
                       otpInputTheme.otpInputFocusBGColor,
                       otpInputTheme.otpInputFocusBorderColor
                    )
            }
            errorStyle={
               errorClassName
                  ? errorClassName
                  : cn(
                       Styles.otpInputErrorStyleStyles,
                       otpInputTheme.otpInputErrorBorderColor,
                       otpInputTheme.otpErrorInputTextColor
                    )
            }
            shouldAutoFocus={shouldAutoFocus}
            isDisabled={isDisabled}
            apiStatus={apiStatus}
            containerStyle={containerStyle}
            onBlur={onBlur}
            isFocus={isFocus}
            placeholder={'000000'}
            hideSeparator={hideSeparator}
         />
      </div>
   )
}
